/*!
 * @license
 * Copyright © 2005-2024 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { BaseApi } from './base.api';
import { throwIfNotDefined } from '../../../assert';
export class SecurityMarksApi extends BaseApi {
    getSecurityMarks(securityGroupId, opts) {
        throwIfNotDefined(securityGroupId, 'securityGroupId');
        const pathParams = {
            securityGroupId
        };
        return this.get({
            path: '/security-groups/{securityGroupId}/security-marks',
            pathParams,
            queryParams: opts
        });
    }
    createSecurityMarks(securityGroupId, securityMarkBody) {
        throwIfNotDefined(securityGroupId, 'securityGroupId');
        throwIfNotDefined(securityMarkBody, 'securityMarkBody');
        const pathParams = { securityGroupId };
        return this.post({
            path: '/security-groups/{securityGroupId}/security-marks',
            pathParams,
            bodyParam: securityMarkBody
        });
    }
    getSecurityMark(securityGroupId, securityMarkId) {
        throwIfNotDefined(securityGroupId, 'securityGroupId');
        throwIfNotDefined(securityMarkId, 'securityMarkId');
        const pathParams = {
            securityGroupId,
            securityMarkId
        };
        return this.get({
            path: '/security-groups/{securityGroupId}/security-marks/{securityMarkId}',
            pathParams
        });
    }
    updateSecurityMark(securityGroupId, securityMarkId, securityMarkBody) {
        throwIfNotDefined(securityGroupId, 'securityGroupId');
        throwIfNotDefined(securityMarkId, 'securityMarkId');
        throwIfNotDefined(securityMarkBody, 'securityMarkBody');
        const pathParams = {
            securityGroupId,
            securityMarkId
        };
        return this.put({
            path: '/security-groups/{securityGroupId}/security-marks/{securityMarkId}',
            pathParams,
            bodyParam: securityMarkBody
        });
    }
    deleteSecurityMark(securityGroupId, securityMarkId) {
        throwIfNotDefined(securityGroupId, 'securityGroupId');
        throwIfNotDefined(securityMarkId, 'securityMarkId');
        const pathParams = {
            securityGroupId,
            securityMarkId
        };
        return this.delete({
            path: '/security-groups/{securityGroupId}/security-marks/{securityMarkId}',
            pathParams
        });
    }
}
